"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCurrency = void 0;
var _react = require("react");
var _contexts = require("../contexts");
/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/**
 * Custom React hook to get the currency for the active locale and to change it to a different currency
 * @returns {{currency: string, setCurrency: function}[]}
 */
const useCurrency = () => {
  const context = (0, _react.useContext)(_contexts.CurrencyContext);
  if (context === undefined) {
    throw new Error('useCurrency must be used within CurrencyProvider');
  }
  return context;
};
exports.useCurrency = useCurrency;